var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:{ active: _vm.expanded },attrs:{"role":"menuitem","aria-expanded":_vm.expanded.toString()},on:{"mouseenter":_vm.expand,"mouseleave":_vm.mouseOut}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }